// src/About.js
import React from 'react';

const About = () => {
  return (
    <div className="homepage-container">
    <div style={{ padding: '2rem' }}>
      <h1>About</h1>
      <p>Welcome to THE DAT CHAIN public ledger. THE DAT CHAIN allows DAT reps to generate digital assets called DATS. DATS are currently available on the SPNDAT Marketplace for purchase using DATCHAIN Tokens. The DAT chain also provides full and transparent analytics to the public associated with all DATS released through the SPNDAT marketplace.</p>
    </div>
<style>{`
  :root{
    --brand-top:#fe24ad;
    --brand-bot:#a410e8;
    --brand-grad:linear-gradient(135deg,var(--brand-top),var(--brand-bot));
    --brand-top-20:rgba(254,36,173,.2);
    --brand-bot-40:rgba(164,16,232,.4);
  }

  /* GLOBAL RESETS & SCROLLBAR STYLING */
  *{margin:0;padding:0;box-sizing:border-box;}
  html,body{
    width:100vw;height:100vh;overflow:hidden;
    background:#000;font-family:sans-serif;color:#fff;
  }
  ::-webkit-scrollbar{width:8px;}
  ::-webkit-scrollbar-track{background:#050008;}
  ::-webkit-scrollbar-thumb{
    background:var(--brand-grad);
    border-radius:4px;box-shadow:0 0 8px rgba(254,36,173,.3);
  }

  /* PAGE CONTAINER */
  .homepage-container{
    width:100vw;height:100vh;
    background:
      radial-gradient(800px 600px at 15% 10%, var(--brand-top-20), transparent 60%),
      radial-gradient(700px 500px at 85% 90%, var(--brand-bot-40), transparent 60%),
      #000;
    color:#fff;
    padding:2rem;display:flex;flex-direction:column;
    animation:fadeInPage 1s ease-in-out;
    border-radius:0;
  }
  @keyframes fadeInPage{from{opacity:0;}to{opacity:1;}}

  h1{
    text-align:center;margin-bottom:1rem;font-size:2.5rem;font-weight:800;
    background:var(--brand-grad);
    -webkit-background-clip:text;background-clip:text;
    -webkit-text-fill-color:transparent;
    text-shadow:0 0 18px rgba(164,16,232,.25);
  }

  /* Content */
  p{text-align:center;color:rgba(255,255,255,.8);}

  /* Optional assets grid (kept themed) */
  .assets-container{flex:1;overflow-y:auto;padding-right:1rem;}
  .assets-list{
    list-style:none;display:grid;grid-template-columns:repeat(2,1fr);
    grid-gap:1rem;padding:0;
  }
  .asset-item{
    display:flex;align-items:center;background:#050008;padding:1rem;border-radius:8px;
    border:1px solid var(--brand-bot-40);
    box-shadow:0 2px 6px rgba(0,0,0,.45);
    transition:transform .3s ease, box-shadow .3s ease;opacity:0;
    animation:fadeInAsset .5s forwards;cursor:pointer;
  }
  .asset-item:hover{transform:translateY(-5px);box-shadow:0 4px 14px rgba(164,16,232,.35);}
  @keyframes fadeInAsset{to{opacity:1;}}
  .asset-image{width:50px;height:50px;object-fit:cover;border-radius:8px;margin-right:1rem;border:2px solid var(--brand-top);}
  .asset-info{display:flex;flex-direction:column;}
  .asset-info>div{margin-bottom:.25rem;font-size:.9rem;}
  .asset-artist{
    font-weight:bold;background:var(--brand-grad);
    -webkit-background-clip:text;-webkit-text-fill-color:transparent;
  }
  .page-title{font-weight:bold;text-align:center;font-size:1rem;margin-bottom:.7rem;background:var(--brand-grad);-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
  .asset-song{font-style:italic;color:rgba(255,255,255,.75);}
  .asset-creator{color:rgba(255,255,255,.6);}

  /* MOBILE TWEAKS */
  @media (max-width:600px){
    .homepage-container{padding:1.5rem 1rem;}
    h1{font-size:2rem;}
    .assets-list{grid-template-columns:1fr;}
  }
`}</style>

    </div>
  );
};

export default About;
